import React, { useState } from "react";
import { Flame, Info, Sparkles, ChefHat } from "lucide-react";
import { useScrollReveal } from "@/hooks/useAnimations";
import { getImageUrl } from "@/config/images";

const MenuPage = () => {
  const [activeCategory, setActiveCategory] = useState("sandwiches");
  const [heroRef, heroVisible] = useScrollReveal({ threshold: 0.3 });
  const [menuRef, menuVisible] = useScrollReveal({ threshold: 0.1 });
  const [sousVideRef, sousVideVisible] = useScrollReveal({ threshold: 0.2 });

  const categories = [
    { id: "sandwiches", name: "SANDWICHES", icon: "🥪" },
    { id: "tortillas", name: "ΤΟΡΤΙΓΙΕΣ", icon: "🌯" },
    { id: "burgers", name: "BURGERS", icon: "🍔" },
    { id: "potatoes", name: "ΠΑΤΑΤΕΣ", icon: "🍟" },
    { id: "drinks", name: "ΠΟΤΑ", icon: "🥤" },
  ];

  const menuItems = {
    sandwiches: [
      {
        name: "SANDWICH ΒΡΩΜΙΑΡΑΣ 3",
        description: "Κοτόπουλο φιλέτο στήθος σιγομαγειρεμένο, πατάτες τηγανητές, flakes παρμεζάνας, baby ρόκα, κρεμμύδι τηγανητό & διπλή χειροποίητη sauce γιαουρτιού.",
        tags: ["signature", "bestseller"],
      },
      {
        name: "SANDWICH CYKA",
        description: "Χοιρινή πανσέτα σιγομαγειρεμένη, πατάτες τηγανητές, flakes παρμεζάνας, λάχανο-καρότο, χειροποίητη BBQ sauce & χειροποίητη sauce γιαουρτιού.",
        tags: ["bestseller"],
      },
      {
        name: "SANDWICH OLD SKOOL",
        description: "Κρέας επιλογής, πατάτες τηγανητές, ντομάτα & mayo Βρωμιάρας.",
        tags: ["classic"],
      },
      {
        name: "SANDWICH OLD SKOOL 2",
        description: "Κρέας επιλογής, πατάτες τηγανητές, ντομάτα, ρόκα, παρμεζάνα, mayo Βρωμιάρας & χειροποίητη BBQ sauce.",
        tags: ["classic"],
      },
      {
        name: "SANDWICH SKINNY PLUS PLUS",
        description: "Πανσέτα σιγομαγειρεμένη, cheddar sauce Βρωμιάρας, παρμεζάνα, ρόκα, λάχανο, καρότο & mayo Βρωμιάρας.",
        tags: ["signature"],
      },
      {
        name: "SANDWICH ΚΑΒΟΥΡΟΠΑΡΤΥ",
        description: "Κοτόπουλο φιλέτο στήθος σιγομαγειρεμένο, πατάτες τηγανητές, flakes παρμεζάνας, αυγό τηγανητό, ντομάτα, baby ρόκα, pesto πιπεριάς Φλωρίνης & mayo Βρωμιάρας.",
        tags: ["loaded"],
      },
      {
        name: "SANDWICH SPECIAL ΠΑΝΣΕΤΑ",
        description: "Διπλή πανσέτα χοιρινή σιγομαγειρεμένη, πατάτες τηγανητές, ντομάτα, baby ρόκα, κρεμμύδι τηγανητό, pesto φέτας & χειροποίητη sauce γιαουρτιού.",
        tags: ["signature", "premium"],
      },
      {
        name: "SANDWICH SPECIAL ΚΟΤΟΠΟΥΛΟ",
        description: "Διπλό κοτόπουλο φιλέτο στήθος σιγομαγειρεμένο, πατάτες τηγανητές, flakes παρμεζάνας, ντομάτα, baby ρόκα, κρεμμύδι τηγανητό & διπλή cheddar sauce Βρωμιάρας.",
        tags: ["sous-vide", "premium"],
      },
      {
        name: "SANDWICH ΤΗΛΕΟΠΤΙΚΟ",
        description: "Μπιφτέκι από ανάμεικτο (μοσχαρίσιο & χοιρινό) κιμά 150gr χειροποίητο, πατάτες τηγανητές, flakes παρμεζάνας, ντομάτα, baby ρόκα, cheddar sauce Βρωμιάρας & mayo Βρωμιάρας.",
        tags: ["sous-vide", "premium"],
      },
      {
        name: "SANDWICH ΥΠΕΡΔΙΑΓΑΛΑΞΙΑΚΟ",
        description: "Μπιφτέκι από ανάμεικτο (μοσχαρίσιο & χοιρινό) κιμά 150gr χειροποίητο, μπέικον, πατάτες τηγανητές, flakes παρμεζάνας, ντομάτα, baby ρόκα, κρεμμύδι τηγανητό, αυγό τηγανητό, cheddar sauce Βρωμιάρας, mayo Βρωμιάρας & χειροποίητη BBQ sauce.",
        tags: ["loaded", "premium"],
      },
      {
        name: "HOT DOG",
        description: "Λουκάνικο τύπου Φρανκφούρτης Θράκης, πατάτες τηγανητές, λάχανο-καρότο, ketchup, μουστάρδα & mayo Βρωμιάρας.",
        tags: ["classic"],
      },
      {
        name: "SANDWICH VEGETARIAN",
        description: "Μανιτάρια πλευρώτους, flakes παρμεζάνας, πατάτες τηγανητές, ντομάτα, baby ρόκα, pesto πιπεριάς Φλωρίνης & mayo Βρωμιάρας.",
        tags: ["vegetarian"],
      },
    ],
    tortillas: [
      {
        name: "ΤΟΡΤΙΓΙΑ ΒΡΩΜΙΑΡΑΣ 3",
        description: "Κοτόπουλο φιλέτο στήθος σιγομαγειρεμένο, flakes παρμεζάνας, πατάτες τηγανητές, baby ρόκα, κρεμμύδι τηγανητό & χειροποίητη sauce γιαουρτιού.",
        tags: ["signature", "bestseller"],
      },
      {
        name: "ΤΟΡΤΙΓΙΑ CYKA",
        description: "Χοιρινή πανσέτα σιγομαγειρεμένη, flakes παρμεζάνας, πατάτες τηγανητές, λάχανο-καρότο, χειροποίητη BBQ sauce & χειροποίητη sauce γιαουρτιού.",
        tags: ["bestseller"],
      },
      {
        name: "ΤΟΡΤΙΓΙΑ OLD SKOOL",
        description: "Κρέας επιλογής, πατάτες τηγανητές, ντομάτα & mayo Βρωμιάρας.",
        tags: ["classic"],
      },
      {
        name: "ΤΟΡΤΙΓΙΑ SKINNY PLUS PLUS",
        description: "Πανσέτα σιγομαγειρεμένη, cheddar sauce Βρωμιάρας, παρμεζάνα, ρόκα, λάχανο, καρότο & mayo Βρωμιάρας.",
        tags: ["signature"],
      },
      {
        name: "ΤΟΡΤΙΓΙΑ ΚΑΒΟΥΡΟΠΑΡΤΥ",
        description: "Κοτόπουλο φιλέτο στήθος σιγομαγειρεμένο, flakes παρμεζάνας, πατάτες τηγανητές, αυγό τηγανητό, ντομάτα, baby ρόκα, pesto πιπεριάς Φλωρίνης & mayo Βρωμιάρας.",
        tags: ["loaded"],
      },
      {
        name: "ΤΟΡΤΙΓΙΑ SPECIAL ΠΑΝΣΕΤΑ",
        description: "Διπλή πανσέτα χοιρινή σιγομαγειρεμένη, ντομάτα, baby ρόκα, πατάτες τηγανητές, κρεμμύδι τηγανητό, pesto φέτας & χειροποίητη sauce γιαουρτιού.",
        tags: ["signature", "premium"],
      },
      {
        name: "ΤΟΡΤΙΓΙΑ SPECIAL ΚΟΤΟΠΟΥΛΟ",
        description: "Διπλό κοτόπουλο φιλέτο στήθος σιγομαγειρεμένο, πατάτες τηγανητές, flakes παρμεζάνας, ντομάτα, baby ρόκα, κρεμμύδι τηγανητό & διπλή cheddar sauce Βρωμιάρας.",
        tags: ["sous-vide", "premium"],
      },
      {
        name: "ΤΟΡΤΙΓΙΑ ΤΗΛΕΟΠΤΙΚΗ",
        description: "Μπιφτέκι από ανάμεικτο (μοσχαρίσιο & χοιρινό) κιμά 150gr χειροποίητο, πατάτες τηγανητές, flakes παρμεζάνας, ντομάτα, baby ρόκα, cheddar sauce Βρωμιάρας & mayo Βρωμιάρας.",
        tags: ["sous-vide", "premium"],
      },
      {
        name: "ΤΟΡΤΙΓΙΑ ΥΠΕΡΔΙΑΓΑΛΑΞΙΑΚΗ",
        description: "Μπιφτέκι από ανάμεικτο (μοσχαρίσιο & χοιρινό) κιμά 150gr χειροποίητο, πατάτες τηγανητές, flakes παρμεζάνας, ντομάτα, baby ρόκα, κρεμμύδι τηγανητό, αυγό τηγανητό, cheddar sauce Βρωμιάρας, mayo Βρωμιάρας & χειροποίητη BBQ sauce.",
        tags: ["loaded", "premium"],
      },
      {
        name: "ΤΟΡΤΙΓΙΑ HOT DOG",
        description: "Λουκάνικο τύπου Φρανκφούρτης Θράκης, πατάτες τηγανητές, λάχανο-καρότο, ketchup, μουστάρδα & mayo Βρωμιάρας.",
        tags: ["classic"],
      },
      {
        name: "ΤΟΡΤΙΓΙΑ VEGETARIAN",
        description: "Μανιτάρια πλευρώτους, flakes παρμεζάνας, πατάτες τηγανητές, ντομάτα, baby ρόκα, pesto πιπεριάς Φλωρίνης & mayo Βρωμιάρας.",
        tags: ["vegetarian"],
      },
    ],
    burgers: [
      {
        name: "VLACHIKO BURGER",
        description: "Μπιφτέκι μοσχαρίσιο, τυρί μετσοβόνε, καραμελωμένα κρεμμύδια, μπέικον, iceberg & pickle mayo.",
        tags: ["signature", "bestseller"],
      },
      {
        name: "ΜΕΤΑΣΥΝΑΥΛΙΑΚΟ",
        description: "Κοτόπουλο φιλέτο στήθος σιγομαγειρεμένο homemade τηγανητό, μπέικον, παρμεζάνα, κρεμμύδι τηγανητό, cheddar sauce Βρωμιάρας, mayo Βρωμιάρας & iceberg.",
        tags: ["new", "premium"],
      },
    ],
    potatoes: [
      {
        name: "ΠΑΤΑΤΕΣ ΤΗΓΑΝΗΤΕΣ",
        description: "Μερίδα φρέσκες πατάτες τηγανητές.",
        tags: ["classic"],
      },
      {
        name: "ΠΑΤΑΤΕΣ ΜΕ CHEDDAR & ΜΠΕΙΚΟΝ",
        description: "Μερίδα πατάτες τηγανητές με cheddar sauce Βρωμιάρας & μπέικον.",
        tags: ["loaded"],
      },
      {
        name: "ΚΟΥΒΑΔΑΚΙ",
        description: "Μερίδα πατάτες τηγανητές με κρέας επιλογής & mayo Βρωμιάρας.",
        tags: ["signature", "loaded"],
      },
      {
        name: "POP N' FRIES",
        description: "Μερίδα πατάτες τηγανητές με popcorn φιλέτο κοτόπουλο & mayo Βρωμιάρας.",
        tags: ["new"],
      },
    ],
    drinks: [
      { name: "Βίκος Cola 330ml", description: "Η κλασική επιλογή για στιγμές απόλαυσης & αναζωογόνησης." },
      { name: "Βίκος Cola Zero 330ml", description: "Η υπέροχη γεύση Cola χωρίς ζάχαρη." },
      { name: "Βίκος Πορτοκαλάδα 330ml", description: "Η απόλυτη δροσιά με αυθεντική γεύση πορτοκαλιού." },
      { name: "Βίκος Πορτοκαλάδα χωρίς ανθρακικό 330ml", description: "Γεύση πορτοκαλιού, χωρίς ανθρακικό." },
      { name: "Βίκος Pink Grapefruit 330ml", description: "Το ροζ φαινόμενο που ξυπνά τις αισθήσεις." },
      { name: "Βίκος Σόδα 330ml", description: "Φυσικό μεταλλικό νερό με ανθρακικό." },
      { name: "Βίκος Νερό 500ml", description: "Εμφιαλωμένο νερό." },
    ],
  };

  const getTagStyle = (tag) => {
    const styles = {
      signature: "bg-yellow-400/20 text-yellow-400 border-yellow-400/30",
      bestseller: "bg-pink-500/20 text-pink-500 border-pink-500/30",
      "sous-vide": "bg-blue-500/20 text-blue-400 border-blue-500/30",
      premium: "bg-purple-500/20 text-purple-400 border-purple-500/30",
      loaded: "bg-orange-500/20 text-orange-400 border-orange-500/30",
      new: "bg-green-500/20 text-green-400 border-green-500/30",
      classic: "bg-gray-500/20 text-gray-400 border-gray-500/30",
      vegetarian: "bg-emerald-500/20 text-emerald-400 border-emerald-500/30",
    };
    return styles[tag] || styles.classic;
  };

  return (
    <div className="min-h-screen bg-black text-white" data-testid="menu-page">
      {/* Hero */}
      <section ref={heroRef} className="relative pt-24 pb-10 md:pt-32 md:pb-14 lg:pt-40 lg:pb-16 bg-zinc-950 overflow-hidden">
        {/* Animated background */}
        <div className="absolute inset-0 opacity-30">
          <img
            src={getImageUrl("food/menu-board.jpeg")}
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
        
        {/* Overlay gradients */}
        <div className="absolute inset-0 bg-gradient-to-b from-black via-transparent to-black" />
        <div className="absolute inset-0 bg-aurora opacity-40" />
        
        {/* Floating elements */}
        <div className="absolute top-20 left-10 animate-float opacity-30">
          <ChefHat className="text-yellow-400" size={40} />
        </div>
        <div className="absolute bottom-20 right-10 animate-float delay-300 opacity-30">
          <Sparkles className="text-pink-500" size={32} />
        </div>
        
        <div className={`relative z-10 max-w-7xl mx-auto px-4 text-center transition-all duration-700 ${heroVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <h1 className="text-4xl md:text-5xl font-bold text-yellow-400 graffiti-text-glow mb-3 font-adelia italic tracking-wide leading-tight">
            The Menu
          </h1>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Πανσέτα σιγομαγειρεμένη 16 ώρες • Sous vide τεχνική • Σπιτικές σάλτσες από τα χεράκια μας
          </p>

          {/* Category Tabs */}
          <div className="flex flex-wrap justify-center gap-2 sm:gap-3 mt-6">
            {categories.map((cat, index) => (
              <button
                key={cat.id}
                onClick={() => setActiveCategory(cat.id)}
                data-testid={`category-${cat.id}`}
                className={`px-3 py-2 sm:px-6 sm:py-3 font-bold text-xs sm:text-lg rounded-lg transition-all duration-300 ease-smooth ${
                  activeCategory === cat.id
                    ? "bg-yellow-400 text-black shadow-lg glow-yellow scale-105"
                    : "bg-white/10 backdrop-blur-sm text-white hover:bg-white/20 hover:scale-102"
                }`}
              >
                <span className="mr-1 sm:mr-2 text-sm sm:text-xl">{cat.icon}</span>
                {cat.name}
              </button>
            ))}
          </div>
        </div>
        {/* Bottom fade */}
        <div className="absolute bottom-0 left-0 right-0 h-24 md:h-32 bg-gradient-to-t from-black to-transparent z-[5]" />
      </section>

      {/* Menu Content */}
      <section ref={menuRef} className="-mt-8 md:-mt-12 pb-16 relative z-10">
        {/* Background texture */}
        <div className="absolute inset-0 bg-grid-pattern opacity-20" />

        <div className="max-w-7xl mx-auto px-4 relative z-10">
          {/* Menu Items */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-testid="menu-items">
            {menuItems[activeCategory]?.map((item, index) => (
              <div
                key={index}
                className={`glass-card rounded-xl p-6 group hover-lift transition-all duration-500 ${menuVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
                style={{ transitionDelay: `${index * 100 + 200}ms` }}
                data-testid={`menu-item-${index}`}
              >
                {/* Top accent line */}
                <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-yellow-400 to-transparent opacity-0 group-hover:opacity-100 transition-opacity rounded-t-xl" />
                
                <div className="mb-3">
                  <h3 className="text-xl font-black text-white group-hover:text-yellow-400 transition-colors duration-300">
                    {item.name}
                  </h3>
                </div>
                <p className="text-gray-400 text-sm mb-4 line-clamp-2">{item.description}</p>
                {item.tags && (
                  <div className="flex flex-wrap gap-2">
                    {item.tags.map((tag, tagIndex) => (
                      <span
                        key={tagIndex}
                        className={`text-xs font-bold px-3 py-1 rounded-full border transition-all duration-300 hover:scale-105 ${getTagStyle(tag)}`}
                      >
                        {tag.toUpperCase()}
                      </span>
                    ))}
                  </div>
                )}
                
                {/* Corner decoration */}
                <div className="absolute bottom-3 right-3 w-6 h-6 border-b-2 border-r-2 border-yellow-400/0 group-hover:border-yellow-400/30 transition-all duration-300" />
              </div>
            ))}
          </div>

          {/* Info Box */}
          <div className={`mt-12 glass-card-pink rounded-xl p-6 relative overflow-hidden transition-all duration-700 delay-500 ${menuVisible ? 'opacity-100' : 'opacity-0'}`} data-testid="menu-info">
            {/* Decorative tape */}
            <div className="absolute -top-2 left-1/4 w-16 h-6 bg-gradient-to-r from-pink-500/60 to-pink-500/40 transform -rotate-6 rounded" />

            <div className="flex items-start gap-4">
              <div className="p-3 bg-pink-500/20 rounded-lg">
                <Info className="text-pink-500 flex-shrink-0" size={24} />
              </div>
              <div>
                <h4 className="text-white font-bold mb-2 text-lg">ΣΗΜΑΝΤΙΚΟ</h4>
                <p className="text-gray-400 text-sm leading-relaxed">
                  Το ψωμί μας είναι το πιο μαλακό στην κατηγορία του - αν δεν του φερθείς όμορφα, στραβώνει!
                  Υπάρχει περίπτωση να μην προλάβεις σήμερα, αλλά αύριο μέρα είναι.
                  <strong className="text-yellow-400 ml-1">Check the SOLD OUT sign & Instagram story!</strong>
                </p>
              </div>
            </div>
          </div>

          {/* Efood Order Banner */}
          <div className={`mt-6 rounded-xl p-6 md:p-8 relative overflow-hidden transition-all duration-700 delay-600 border border-red-500/20 ${menuVisible ? 'opacity-100' : 'opacity-0'}`} style={{ background: 'linear-gradient(135deg, rgba(180,40,35,0.15) 0%, rgba(220,60,50,0.10) 50%, rgba(255,100,80,0.08) 100%)' }}>
            <div className="absolute inset-0 bg-grid-pattern opacity-10" />
            <div className="absolute -top-10 -right-10 w-40 h-40 bg-white/10 rounded-full blur-2xl" />

            <div className="relative z-10 flex flex-col md:flex-row items-center gap-6 text-center md:text-left">
              <div className="flex-1">
                <h3 className="text-2xl md:text-3xl font-black text-white mb-3" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>
                  ΠΑΡΑΓΓΕΙΛΕ ΤΩΡΑ!
                </h3>
                <p className="text-white/90 text-sm md:text-base leading-relaxed">
                  Βρες μας στο <strong>efood</strong> και παράγγειλε τα αγαπημένα σου στο σπίτι!
                </p>
              </div>
              <a
                href="https://www.e-food.gr/delivery/ioannina/i-vromiara-the-gourmet-street-food-6931472"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 bg-red-500/20 text-white border border-red-500/30 px-8 py-4 rounded-lg font-black text-lg hover:bg-red-500/40 transition-all duration-300 magnetic-btn whitespace-nowrap"
              >
                <img
                  src="https://www.e-food.gr/favicon.ico"
                  alt="efood"
                  className="w-6 h-6"
                />
                EFOOD →
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Sous Vide Info */}
      <section ref={sousVideRef} className="py-20 bg-zinc-950 relative overflow-hidden" data-testid="sousvide-section">
        {/* Background elements */}
        <div className="absolute inset-0 bg-mesh-gradient opacity-40" />
        <div className="absolute top-10 left-10 w-40 h-40 bg-yellow-400/5 rounded-full blur-3xl" />
        <div className="absolute bottom-10 right-10 w-60 h-60 bg-pink-500/5 rounded-full blur-3xl" />
        
        <div className={`max-w-4xl mx-auto px-4 text-center relative z-10 transition-all duration-700 ${sousVideVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
          <div className="inline-block p-4 bg-yellow-400/10 rounded-full mb-6 animate-float">
            <Flame className="text-yellow-400" size={48} />
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-white mb-6" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>
            ΤΙ ΕΙΝΑΙ ΤΟ <span className="gradient-text-animated">SOUS VIDE</span>;
          </h2>
          <p className="text-gray-400 text-lg leading-relaxed mb-8">
            Η τεχνική sous vide (&quot;κάτω από κενό&quot; στα γαλλικά) μαγειρεύει το κρέας σε ακριβώς ελεγχόμενη 
            θερμοκρασία για ώρες, δημιουργώντας τρυφερότητα και γεύση που δεν μπορείς να πετύχεις αλλιώς. 
            Η πανσέτα μας σιγομαγειρεύεται για <strong className="text-yellow-400">16 ολόκληρες ώρες</strong>.
          </p>
          
          
          <div className="inline-flex gap-3">
            <span className="tag-street bg-yellow-400/10 text-yellow-400">#SOUSVIDE</span>
            <span className="tag-street bg-pink-500/10 text-pink-500">#VRMR</span>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MenuPage;
